import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

// eslint-disable-next-line import/prefer-default-export
export const useDatasetMappedValue = (
  mapValue: number | undefined,
  mapperId: number
): { value: string; isLoading: boolean } => {
  const { data, isLoading } = useGetDatasetMapperData(mapperId);

  if (isLoading) return { value: "", isLoading };
  if (mapValue === undefined) return { value: "N/A", isLoading };
  if (!data || !data.mappings) return { value: mapValue.toString(), isLoading };
  return { value: data.mappings[mapValue].toString(), isLoading };
};
